export default {
  title: {
    en: 'Your subscription has been canceled',
  },
  subTitle: {
    en: 'Your account has already been charged for the next order.',
  },
  subTitleForNotChargedUser: {
    en: `
      Please note, all accounts are charged on the 5th of each month,
      so you will still be charged in this billing cycle.
    `,
  },
  subTitleForNotChargedUser1st: {
    en: `
      Please note, all accounts are charged on the 1st of each month,
      so you will still be charged in this billing cycle.
    `,
  },
  text: {
    en: `
      You can choose to receive your final shipment, or have the payment refunded.
      Please note: all refunds take 7-10 business days.
    `,
  },
  refundButton: {
    en: 'Get a refund',
  },
  receiveButton: {
    en: 'Receive Order',
  },
  receiveButtonForNotChargedUser: {
    en: 'Receive Scentbird',
  },
}
